import { ActionConfigurationIdentifiers } from 'modules/processes/domain'

import { Editor } from './Editor'
import { Preview } from './Preview'
import { Selector } from './Selector'

export const sendCustomEmailWizardActions = {
  [ActionConfigurationIdentifiers.SendCustomEmail]: {
    selector: Selector,
    preview: Preview,
    editor: Editor,
  },
}
